import { useMemo, useState } from 'react'
import * as TomadaHttp from '../../../../services/api/https/patio/tomada.http'
import { errorHandler } from '../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  INITIAL_GET: 'Adquirindo informações das tomadas',
}

const INITIAL_STATE = {
  tomadas: [],
  modal: { show: false, data: null },
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  selectedTp: 0,
  globalFilter: '',
}

export default function useTomada() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      async getTomadas(tp_id) {
        try {
          const list = await TomadaHttp.getTomadas(tp_id)
          setState(prev => ({
            ...prev,
            tomadas: list || [],
            loadingMessage: LOAD_MESSAGE.NONE,
          }))
        } catch (err) {
          setState(prev => ({
            ...prev,
            loadingMessage: LOAD_MESSAGE.NONE,
            errorMessage: errorHandler(err),
          }))
        }
      },
      resetState() {
        setState({ ...INITIAL_STATE })
      },
      onInit(selectedTp) {
        setState(prev => ({
          ...prev,
          selectedTp: selectedTp,
          loadingMessage: selectedTp ? LOAD_MESSAGE.INITIAL_GET : LOAD_MESSAGE.NONE,
          errorMessage: selectedTp ? null : 'Selecione o Operador Logístico',
        }))
      },
      onBtnNovo() {
        setState(prev => ({ ...prev, modal: { show: true, data: null } }))
      },
      onModalClose() {
        setState(prev => ({ ...prev, modal: { show: false, data: null } }))
      },
      onModalSave(tomada) {
        setState(prev => {
          const copy = { ...prev }
          copy.modal = { show: false, data: null }
          const idx = copy.tomadas.findIndex(b => b.id === tomada.id)
          if (idx !== -1) copy.tomadas[idx] = tomada
          else copy.tomadas.unshift(tomada)
          return copy
        })
      },
      onGlobalFilterChange(value) {
        setState(prev => ({ ...prev, globalFilter: value }))
      },
      onRowClick(tomada) {
        setState(prev => ({ ...prev, modal: { show: true, data: tomada } }))
      },
    }
  }, [])

  return { state, localDispatch }
}
